// extracted by mini-css-extract-plugin
export default {"logo-wrap":"SessionResults_logo-wrap__xb3P3","list-item-clear-list":"SessionResults_list-item-clear-list__7duqR"};